// desired number of subdivisions
const numberOfDivisions = 3

// values that are round will be used y axis divisions
const values = [
  1,
  2,
  2.5,
  4,
  5,
]

/*
 * returns the number of units between each label on the y axis
 */
export function graphRangeToUnitsPerLabel(range: number): number {
  // the ideal division if the range were divided evenly in "numberOfDivisions" parts
  const targetDivision = range / numberOfDivisions

  // the greatest power of ten that is less than targetDivision
  const log = Math.floor(Math.log10(targetDivision))

  // transpose the targetDivision into a range between 1 (inclusive) and 10
  // (exclusive) so that we can compare it to the values array
  const targetValue = targetDivision / Math.pow(
    10,
    log,
  )

  // gets the nearest value from values array
  const nearestValue = values.reduce(
    (nearValue, nextValue) => {
      const nearestDiff = Math.abs(targetValue - nearValue)
      const nextDiff = Math.abs(targetValue - nextValue)

      if (nextDiff <= nearestDiff) {
        return nextValue
      }

      return nearValue
    },
    values[0],
  )

  // transpose the value by log powers of ten so it is close to targetDivision again
  return nearestValue * Math.pow(
    10,
    log,
  )
}
